import { CheckCircle2, ExternalLink, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const TIER_CLS = {
  preventive: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300',
  standard:   'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
  formal:     'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
  urgent:     'bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300',
  escalation: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
};
const TIER_LABEL = {
  preventive: 'Prev.', standard: 'Std.', formal: 'Formal', urgent: 'Urg.', escalation: 'Esc.',
};

function formatEur(n) {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency', currency: 'EUR', minimumFractionDigits: 0,
  }).format(Number(n ?? 0));
}

/**
 * CollectionCycleResult — shown after recordatorio_facturas_vencidas executes.
 * Displays facturas processed, tier breakdown chips, total recovered, and a
 * deeplink to the overdue invoices list.
 */
export default function CollectionCycleResult({ result }) {
  if (!result) return null;
  const tierBreakdown = result.tier_breakdown ?? {};
  const tiers = Object.entries(tierBreakdown).filter(([, n]) => n > 0);

  return (
    <div className="rounded-xl border border-success/30 bg-success/10 p-3 my-1 max-w-sm space-y-2">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <CheckCircle2 className="w-4 h-4 text-success shrink-0" />
          <div className="min-w-0">
            <p className="text-xs font-semibold text-foreground">
              Ciclo de cobro · <Zap className="w-3 h-3 inline text-indigo-500" /> ARIA
            </p>
            <p className="text-[10px] text-muted-foreground">
              {result.facturas_procesadas} factura{result.facturas_procesadas !== 1 ? 's' : ''} · {formatEur(result.total_vencido)}
              {result.sin_email > 0 && ` · ${result.sin_email} sin email`}
            </p>
          </div>
        </div>
        <Link to="/facturas?tab=lista-v2&status=overdue">
          <Button size="sm" variant="outline"
            className="h-7 text-[11px] shrink-0 gap-1 border-success/30 text-success hover:bg-success/10">
            Ver
            <ExternalLink className="w-3 h-3" />
          </Button>
        </Link>
      </div>

      {tiers.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {tiers.map(([tier, n]) => (
            <span key={tier}
              className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium ${TIER_CLS[tier] ?? ''}`}>
              {TIER_LABEL[tier] ?? tier} · {n}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
